// src/routes/AdminRoutes.jsx
import React from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  Outlet,
} from "react-router-dom";
import DashboardLayout from "../components/layout/DashboardLayout";
import AdminUsers from "../AdminPages/AdminUsers";
import ValidReservations from "../AdminPages/ValidReservations";
import DoNotTow from "../AdminPages/DoNotTow";
import AdminLogin from "../AdminPages/AdminLogin";
import ProtectedRoute from "../components/routing/ProtectedRoute";
import { useAuth } from "../auth/AuthContext";
import AccessLogs from "../AdminPages/AccessLogs";

function AdminLoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  return (
    <AdminLogin
      onSuccess={(payload) => {
        login(payload, true);
        const from = location.state?.from?.pathname || "/admin/dashboard";
        navigate(from, { replace: true });
      }}
    />
  );
}

function AdminProtectedLayout() {
  const { logout } = useAuth();
  return (
    <ProtectedRoute redirectTo="/admin/login">
      <DashboardLayout onLogout={logout}>
        <Outlet />
      </DashboardLayout>
    </ProtectedRoute>
  );
}

export default function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<AdminLoginPage />} />
      <Route element={<AdminProtectedLayout />}>
        <Route path="dashboard" element={<AdminUsers />} />
        <Route path="valid-reservations" element={<ValidReservations />} />
        <Route path="do-not-tow" element={<DoNotTow />} />
        <Route path="access-logs" element={<AccessLogs />} />
        <Route index element={<Navigate to="dashboard" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/admin/login" replace />} />
    </Routes>
  );
}
